export default [
  {
    code: 'MAD',
    country: 'Spain',
    countryId: 'ES',
    name: 'Madrid',
    lat: 40.4839,
    lon: -3.568
  },
  {
    code: 'BCN',
    country: 'Spain',
    countryId: 'ES',
    name: 'Barcelona',
    lat: 41.2974,
    lon: 2.0833
  },
  {
    code: 'CDG',
    country: 'France',
    countryId: 'FR',
    name: 'Paris Charles de Gaulle',
    lat: 49.0097,
    lon: 2.5479
  },
  {
    code: 'ORY',
    country: 'France',
    countryId: 'FR',
    name: 'Paris Orly',
    lat: 48.7262,
    lon: 2.3652
  },
  {
    code: 'NCE',
    country: 'France',
    countryId: 'FR',
    name: 'Nice',
    lat: 43.6598,
    lon: 7.2148
  },
  {
    code: 'LYS',
    country: 'France',
    countryId: 'FR',
    name: 'Lyon',
    lat: 45.7234,
    lon: 5.0888
  },
  {
    code: 'LHR',
    country: 'United Kingdom',
    countryId: 'UK',
    name: 'London Heathrow',
    lat: 51.47,
    lon: -0.4543
  },
  {
    code: 'LGW',
    country: 'United Kingdom',
    countryId: 'UK',
    name: 'London Gatwick',
    lat: 51.1537,
    lon: -0.1821
  },
  {
    code: 'MAN',
    country: 'United Kingdom',
    countryId: 'UK',
    name: 'Manchester',
    lat: 53.3588,
    lon: -2.2727
  },
  {
    code: 'DUB',
    country: 'Ireland',
    countryId: 'IE',
    name: 'Dublin',
    lat: 53.4264,
    lon: -6.2499
  },
  {
    code: 'CPH',
    country: 'Denmark',
    countryId: 'DE',
    name: 'Copenhagen',
    lat: 55.618,
    lon: 12.6508
  },
  {
    code: 'AMS',
    country: 'Netherlands',
    countryId: 'NL',
    name: 'Amsterdam',
    lat: 52.3105,
    lon: 4.7683
  },
  {
    code: 'RTM',
    country: 'Netherlands',
    countryId: 'NL',
    name: 'Rotterman',
    lat: 51.9555,
    lon: 4.4399
  },
  {
    code: 'TXL',
    country: 'Germany',
    countryId: 'DE',
    name: 'Berlin Tegel',
    lat: 52.5588,
    lon: 13.2884
  },
  {
    code: 'FRA',
    country: 'Germany',
    countryId: 'DE',
    name: 'Frankfurt',
    lat: 50.0379,
    lon: 8.5622
  },
  {
    code: 'HAM',
    country: 'Germany',
    countryId: 'DE',
    name: 'Hamburg',
    lat: 53.6336,
    lon: 9.9974
  },
  {
    code: 'MUC',
    country: 'Germany',
    countryId: 'DE',
    name: 'Munich',
    lat: 48.3537,
    lon: 11.775
  },
  {
    code: 'GVA',
    country: 'Switzerland',
    countryId: 'CH',
    name: 'Geneva',
    lat: 46.237,
    lon: 6.1092
  },
  {
    code: 'ARN',
    country: 'Sweden',
    countryId: 'SE',
    name: 'Stockholm Arlanda',
    lat: 59.6498,
    lon: 17.9238
  },
  {
    code: 'ZRH',
    country: 'Switzerland',
    countryId: 'CH',
    name: 'Zurich',
    lat: 47.4582,
    lon: 8.5555
  },
  {
    code: 'BRU',
    country: 'Belgium',
    countryId: 'BE',
    name: 'Brussels',
    lat: 50.901,
    lon: 4.4856
  },
  {
    code: 'FCO',
    country: 'Italy',
    countryId: 'IT',
    name: 'Rome Fiumicino',
    lat: 41.7999,
    lon: 12.2462
  },
  {
    code: 'MXP',
    country: 'Italy',
    countryId: 'IT',
    name: 'Milan Malpensa',
    lat: 45.6301,
    lon: 8.7255
  },
  {
    code: 'VIE',
    country: 'Austria',
    countryId: 'AT',
    name: 'Vienna',
    lat: 48.1158,
    lon: 16.5666
  },
  {
    code: 'PRG',
    country: 'Czech Republic',
    countryId: 'CZ',
    name: 'Prague',
    lat: 50.1018,
    lon: 14.2632
  },
  {
    code: 'OPO',
    country: 'Portugal',
    countryId: 'PT',
    name: 'Porto',
    lat: 41.2421,
    lon: -8.6786
  },
  {
    code: 'LIS',
    country: 'Portugal',
    countryId: 'PT',
    name: 'Lisbon',
    lat: 38.7756,
    lon: -9.1354
  },
  {
    code: 'OSL',
    country: 'Norway',
    countryId: 'NO',
    name: 'Oslo',
    lat: 60.1976,
    lon: 11.1004
  }
  // {
  //   code: 'JFK',
  //   country: 'United States',
  //   countryId: 'US',
  //   name: 'New York John F. Kennedy'
  // },
  // {
  //   code: 'LGA',
  //   country: 'United States',
  //   countryId: 'US',
  //   name: 'New York LaGuardia'
  // },
  // {
  //   code: 'SFO',
  //   country: 'United States',
  //   countryId: 'US',
  //   name: 'San Francisco'
  // }
];



// WEBPACK FOOTER //
// ./src/airports.js